type AuthErrorBody = {
  error?: unknown;
  error_code?: unknown;
  error_description?: unknown;
  message?: unknown;
  msg?: unknown;
};

function text(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

export function getAuthErrorCode(body: unknown): string {
  if (!body || typeof body !== "object") return "";
  const error = body as AuthErrorBody;
  return text(error.error_code) || text(error.error);
}

export function getLoginErrorMessage(status: number, body: unknown): string {
  const code = getAuthErrorCode(body);
  const detail =
    body && typeof body === "object"
      ? text((body as AuthErrorBody).msg) ||
        text((body as AuthErrorBody).message) ||
        text((body as AuthErrorBody).error_description)
      : "";

  switch (code) {
    case "invalid_credentials":
      return "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจตัวพิมพ์เล็ก-ใหญ่แล้วลองใหม่";
    case "email_not_confirmed":
      return "บัญชีนี้ยังไม่ได้ยืนยันอีเมลใน Supabase Auth";
    case "email_provider_disabled":
      return "ยังไม่ได้เปิดใช้งาน Email provider ใน Supabase Auth";
    case "over_request_rate_limit":
    case "over_email_send_rate_limit":
      return "ทดลองเข้าสู่ระบบถี่เกินไป กรุณารอสักครู่แล้วลองใหม่";
    case "captcha_failed":
      return "การตรวจสอบความปลอดภัยไม่สำเร็จ กรุณาลองใหม่";
    case "user_banned":
      return "บัญชีนี้ถูกระงับใน Supabase Auth";
  }

  if (code === "invalid_api_key" || /invalid\s+(api\s+)?key/i.test(detail)) {
    return "Supabase Publishable Key ไม่ถูกต้อง กรุณาตรวจ .env แล้ว build และ deploy ใหม่";
  }
  if (status === 401) {
    return detail
      ? `Supabase Auth ปฏิเสธคำขอ: ${detail}`
      : "Supabase Auth ปฏิเสธคำขอ กรุณาตรวจ Auth Logs";
  }
  if (status === 429) {
    return "ทดลองเข้าสู่ระบบถี่เกินไป กรุณารอสักครู่แล้วลองใหม่";
  }
  if (status >= 500) {
    return "Supabase Auth ขัดข้องชั่วคราว กรุณาลองใหม่ภายหลัง";
  }

  return detail
    ? `เข้าสู่ระบบไม่สำเร็จ: ${detail}`
    : "เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจบัญชีใน Supabase Auth";
}
